import React from "react";

class MeasurementOrder {
    public Direction: string = "1";
    public Position: string = "0";
}

const measurementOrder = new MeasurementOrder();
export default measurementOrder;